<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.selecciona_sector') }}</h2>
        </b-col>
        <b-col cols="8">
            <h3 class="subtitle h4 light mb-3 mb-lg-4">A) {{ $t('nuevo_abono.pinchando_mapa') }}:</h3>
            <SvgComponent 
                :zonas="regiones" 
                :place="recinto" 
                @clickZona="clickZona"
                @cargado="loading = false"
            />
        </b-col>
        <b-col cols="4">
            <h3 class="subtitle h4 light mb-3 mb-lg-4 ">B) {{ $t('nuevo_abono.tabla') }}:</h3>
            <div class="lightgray-content p-2 pb-0">
                <TablaSectoresComponent :zonas="regiones" @clickZona="clickZona"/>
            </div>
        </b-col>
    </b-row>    
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    export default {
        data() {
            return {
                loading: true,
                regiones: []
            }
        },
        created() {
            this.getRegiones();
        },
        methods: {
            getRegiones() {
                let params = {
                    filters: {}
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.lfp.regiones'), params).then(res => {
                    this.regiones = res.data.data;
                }).catch(error => {
                    this.$toast.error('A ocurrido un error');
                });
            
            },
            clickZona(zona) {
                this.$emit('regionSeleccionada', zona);
            }
        },
        computed: {
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        components: {
            SvgComponent, TablaSectoresComponent
        }
    }
</script>